import styled from 'styled-components';
import { ErrorBanner } from 'ui/banner';
import { Accordion, AccordionContent, AccordionHeader } from 'ui/accordion';
import { spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { PreviewWithDataErrorMessage } from './types';

const StyledErrorBanner = styled(ErrorBanner)`
  align-items: baseline;

  @media screen and (max-width: ${pxToRem(893)}) {
    width: 100%;
  }
  margin-bottom: ${spacing.double};
`;

const StyledAccordion = styled(Accordion)`
  background-color: inherit;
  padding: 0;
`;

export const PreviewWithDataError = ({
  previewError,
}: {
  previewError: PreviewWithDataErrorMessage;
}) => (
  <StyledErrorBanner>
    <StyledAccordion>
      <AccordionHeader arrowHeight={22} arrowWidth={22}>
        <>{previewError.label}</>
      </AccordionHeader>
      <AccordionContent>
        <>{previewError.errorMessage}</>
      </AccordionContent>
    </StyledAccordion>
  </StyledErrorBanner>
);
